import C from 'actionTypes'

export const setBlackDiamondError = () => ({
  type: C.SET_BLACK_DIAMOND_ERROR
})

export const setBoxError = () => ({
  type: C.SET_BOX_ERROR
})

export default {
  setBlackDiamondError,
  setBoxError,
}



// WEBPACK FOOTER //
// ./src/actions/client/errors.js